module.exports = __webpack_public_path__ + "static/img/009_TO8_1467.21025cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/009_TO8_1467.jpg
// module id = jDqb
// module chunks = 0